import React from "react";

interface PageHeaderProps {
  title: string;
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, action }) => {
  return (
    <div className="flex my-2 gap-2 flex-col sm:flex-row items-start sm:items-center flex-wrap justify-between shrink-0">
      <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
      {action}
    </div>
  );
};

export default PageHeader;
